export default __webpack_public_path__ + "static/media/Viet.3d43f0da.png";